import { IIconBase } from '..'

const trashModalIcon = ({
  color = '#DC3545',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/trash'>
        <g id='trash'>
          <path
            id='Vector'
            d='M35.5 9.96615C29.95 9.41615 24.3667 9.13281 18.8 9.13281C15.5 9.13281 12.2 9.29948 8.9 9.63281L5.5 9.96615'
            stroke={color}
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M14.667 8.28398L15.0337 6.10065C15.3003 4.51732 15.5003 3.33398 18.317 3.33398H22.6837C25.5003 3.33398 25.717 4.58398 25.967 6.11732L26.3337 8.28398'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M31.9163 15.2324L30.833 32.0158C30.6497 34.6324 30.4997 36.6658 25.8497 36.6658H15.1497C10.4997 36.6658 10.3497 34.6324 10.1663 32.0158L9.08301 15.2324'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M17.7168 27.5H23.2668'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_5'
            d='M16.333 20.834H24.6663'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default trashModalIcon
